import { EntityApiService } from '@dfl/react-security';
import { IAudit } from '../interfaces';

class AuditCreateService extends EntityApiService<IAudit> {}

export default new AuditCreateService('/ms-core/api/audit');
